import { Stack } from "react-bootstrap";
import styled from "styled-components";

export const StyledCardStack = styled(Stack)`
  flex: 1;
  min-height: 0;
  overflow: auto;
`;
